/**
 * CreateCohortModal Messages
 *
 * This contains all the text for the CreateCohortModal component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.cohorts.createModal';

export default defineMessages({
  newCohort: {
    id: `${scope}.newCohort`,
    defaultMessage: 'New class',
  },
  cohortName: {
    id: `${scope}.cohortName`,
    defaultMessage: 'Class name',
  },
  cohortNamePlaceholder: {
    id: `${scope}.cohortNamePlaceholder`,
    defaultMessage: 'E.g. Bio 101',
  },
  startDate: {
    id: `${scope}.startDate`,
    defaultMessage: 'Start date',
  },
  open: {
    id: `${scope}.open`,
    defaultMessage: 'Open enrollment',
  },
  passport: {
    id: `${scope}.passport`,
    defaultMessage: 'Use Passport to enroll students',
  },
  lti: {
    id: `${scope}.lti`,
    defaultMessage: 'Use LTI to enroll students',
  },
  ltiFindKeys: {
    id: `${scope}.ltiFindKeys`,
    defaultMessage: 'You can find the keys in the class setting page.',
  },
  productId: {
    id: `${scope}.productId`,
    defaultMessage: 'Pearson Product ID (PPID)',
  },
  productIdPlaceholder: {
    id: `${scope}productIdPlaceholder`,
    defaultMessage: 'Eg. x-urn:revel:aeb7fa90-b134-11ea-9f4d-a5b246f9138c',
  },
  productIdMessage: {
    id: `${scope}.productIdMessage`,
    defaultMessage: 'A PPID is currently required for some learner-facing features, but it can be added later in the class settings page.',
  },
  productModel: {
    id: `${scope}.productModel`,
    defaultMessage: 'Product Model',
  },
  productModelPlaceholder: {
    id: `${scope}.productModelPlaceholder`,
    defaultMessage: 'Select a product model',
  },
  createCohort: {
    id: `${scope}.createCohort`,
    defaultMessage: 'Create class',
  },
});
